const EMPTY_DOC_PATTERN = /^(?:<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>)*$/i

function normalize(html: string): string {
	return html.replace(/\s+/g, " ").replace(/>\s+</g, "><").trim()
}

export function isEmptyDescriptionHtml(html: string): boolean {
	return EMPTY_DOC_PATTERN.test(normalize(html))
}

/**
 * True while the description still holds only what we auto-populated from the
 * thread, so a Linear template's own description can take its place.
 */
export function isSeededDescription(
	currentHtml: string,
	seededHtml: string,
): boolean {
	if (isEmptyDescriptionHtml(currentHtml)) return true
	return normalize(currentHtml) === normalize(seededHtml)
}
